import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import {
  ProSkillManagerActionUserInfoModel
} from "~~/package/mapper/proSkillManager/model/actions/ProSkillManagerActionUserInfoModel";
import { ProSkillAssureCandidateSetScoreModel } from "~~/package/mapper/proSkillAssure/model/candidate/ProSkillAssureCandidateSetScoreModel";

export class ProSkillMangerReportModel extends Model {
  constructor(
    public title: string | null = null,
    public endedAt: string | null = null,
    public rank: number = 0,
    public score: number = 0,
    public timeTaken: number = 0,
    public actionCount: number = 0,
    public userInfo: ProSkillManagerActionUserInfoModel = new ProSkillManagerActionUserInfoModel(),
    public assessmentCandidatesSet: ProSkillAssureCandidateSetScoreModel[] = [],
    public isUnsubmitted: boolean = false
  ) {
    super();
  }

  public static create(model: Partial<ProSkillMangerReportModel>): ProSkillMangerReportModel {
    return createModel<ProSkillMangerReportModel>(ProSkillMangerReportModel, {
      ...model
    });
  }
}
